var _mask, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSmallArrow = function SvgSmallArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "-3 -3 22 22"
  }, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "smallArrow_svg__a",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3.344 6.569a.533.533 0 0 1 .754-.024L8 10.203l3.902-3.658a.533.533 0 0 1 .73.778l-4.267 4a.533.533 0 0 1-.73 0l-4.266-4a.533.533 0 0 1-.025-.754",
    clipRule: "evenodd"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#09090B",
    fillRule: "evenodd",
    d: "M3.344 6.569a.533.533 0 0 1 .754-.024L8 10.203l3.902-3.658a.533.533 0 0 1 .73.778l-4.267 4a.533.533 0 0 1-.73 0l-4.266-4a.533.533 0 0 1-.025-.754",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M3.344 6.569 2.25 5.543zm.754-.024L3.072 7.639zM8 10.203l-1.026 1.094L8 12.259l1.026-.962zm3.902-3.658L10.876 5.45zm.754.024 1.094-1.026zm-.025.754 1.026 1.094zm-4.266 4 1.026 1.094zm-.73 0L6.61 12.417zm-4.266-4 1.025-1.094zm-.025-.754L4.44 7.595a.967.967 0 0 1-1.367.044l1.026-1.094L5.124 5.45a2.033 2.033 0 0 0-2.874.093zm.754-.024L3.072 7.639l3.902 3.658L8 10.203l1.026-1.095L5.124 5.45zM8 10.203l1.026 1.094 3.902-3.658-1.026-1.094-1.026-1.095-3.902 3.658zm3.902-3.658 1.026 1.094a.967.967 0 0 1-1.367-.044l1.095-1.026 1.094-1.026a2.034 2.034 0 0 0-2.874-.093zm.754.024L11.56 7.595a.967.967 0 0 1 .044-1.366l1.026 1.094 1.027 1.094c.819-.768.86-2.055.092-2.874zm-.025.754-1.026-1.094-4.266 4 1.026 1.094 1.026 1.094 4.266-4zm-4.266 4-1.026-1.094a.967.967 0 0 1 1.322 0l-1.026 1.094-1.026 1.094c.782.733 2 .733 2.782 0zm-.73 0 1.026-1.094-4.267-4L3.37 7.323 2.343 8.417l4.266 4zm-4.266-4 1.025-1.095c.39.366.41.977.045 1.367L3.344 6.569 2.25 5.543a2.033 2.033 0 0 0 .093 2.874z",
    mask: "url(#smallArrow_svg__a)"
  })));
};
export default SvgSmallArrow;